import "./logrocket-init.ts";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CustomAppProvider } from "contexts/CustomAppContext";

ReactDOM.render(
  <React.StrictMode>
    <CustomAppProvider>
      <App />
    </CustomAppProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
